<template>
	<div v-parallax-fit="parallax" class="hand">
		<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/18_FinalNoticeHand@2x.png" alt="">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 9000,
						end: 24000,
						fromStyle: { transform: 'translateY(-500%)' },
           				toStyle: { transform: 'translateY(0%)' },
						easing: 'linear'
					},
					{
						start: 24500,
						end: 26000,
						fromStyle: { transform: 'translateY(0%)' },
           				toStyle: { transform: 'translateY(-500%)' },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.hand {
		position: absolute;
		left: 100%;
		bottom: 100%;
		transition: all 0.5s linear;
		width: 350px;
		margin-left: -125px;
		margin-bottom: -300px;
	}

	@media screen and (max-width: 1600px) {
		.hand {width: 320px;}
	}

	@media screen and (max-width: 991px) {
		.hand {
			width: 270px;
			margin-bottom: -255px;
		}
	}

	@media screen and (max-width: 650px) {
		.hand {
			width: 190px;
		    margin-bottom: -142px;
		    margin-left: -150px;
		}
	}
</style>
